import { Component, OnInit, OnDestroy } from '@angular/core';


@Component({
    selector: 'home',
    styleUrls: ['./home.component.css'],
    templateUrl: './home.component.html'
})
export class HomeComponent {
  showSideBar = false;
  constructor() {
    this.showSideBar = false;

  }

  showMenu() {
    this.showSideBar = true;
  }

  hideMenu() {
    this.showSideBar = false;
  }


}
